import { ChartDotRadius } from './constants/index.jsx';

export { default as Charts } from './Charts.jsx';
export { default as Chart } from './Chart.jsx';
export { default as ChartSoil } from './ChartSoil.jsx';
export { default as ChartRain } from './ChartRain.jsx';

export { default as ChartLegend } from './ChartLegend.jsx';
export { default as ChartLegendSoil } from './ChartLegendSoil.jsx';
export { default as ChartLegendItemCircle } from './ChartLegendItemCircle.jsx';

export { default as ChartTooltip } from './ChartTooltip.jsx';
export { default as ChartSoilTooltip } from './ChartSoilTooltip.jsx';

export { default as ChartsPeriodNav } from './ChartsPeriodNav.jsx';
export { default as ChartsTypeNav } from './ChartsTypeNav.jsx';
export { default as ChartNav } from './ChartNav.jsx';

export { default as ChartsCustomFilter } from './ChartsCustomFilter.jsx';
export { default as ChartsCustomSettings } from './ChartsCustomSettings.jsx';
export { default as ChartsCustomNav } from './ChartsCustomNav.jsx';
export { default as ChartsTypeNavCurrent } from './ChartsTypeNavCurrent.jsx';

export const ChartActiveDot = (color) => {
  return { r: ChartDotRadius, fill: '#fff', stroke: color }
}
